<template>
<div >
  <common ref="common" />
    <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Terms and Conditions</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
            icon
            dark
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
    </v-toolbar>
  <v-sheet >
    <div  class=" h-100 mx-6 py-5 pb-10 pt-5">
      <div>     Please read these terms carefully before using the online payment facility. Using the
online payment facility on this website indicates that you accept these terms. If you
do not accept these terms, do not use this facility.
The following terms and conditions shall apply to you as a Member of Vyapari
Vyavasayi Ekopana Samithi Palakkad, a Society under the Societies Registration Act
XXI, 1860 with registration number PKD/CA/427/2023. and having its registered
office at Kerala Vyapari Vyavasayi Ekopana Samithi, 41/2235, Vyaparabhavan,
Manjakkulam Road, Palakkad – 678014, with access to online payment system as
provided by Vyapari Vyavasayi Ekopana Samithi Palakkad and we assure to
maintain the confidential information as set out herein.
      </div>
      <div class="d-flex pt-5">
        <h3>All payments are subject to the following conditions</h3>
      </div>
      
      <div class="d-flex pt-5">
        <h3>Society&#39;s Obligations</h3>
      </div>
      <div class="pt-2"> We may update these terms from time to time and any changes will be effective
immediately on being set out here. Please ensure you are aware of the current
terms.
The description of services of online amount payment are specific to your scheme,
when you log in with your unique password. All amount quoted are in Indian Rupees.
M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad reserves the right to change the
amount at any time. Refer the service confirmation against the amount prior to
processing the payment.
      </div>

      <div class="d-flex pt-5">
        <h3>Liability</h3>
      </div>
      <div class="pt-2"> Your payment will normally reach Vyapari Vyavasayi Ekopana Samithi Palakkad
account to which you are making a payment within two working days.
<ul> <li> We cannot accept liability for a payment not reaching the correct Vyapari
Vyavasayi Ekopana Samithi Palakkad account due to you quoting an incorrect
account number or incorrect personal details. Neither can we accept liability if
payment is refused or declined by the credit/debit card supplier for any reason.
 </li> <li> If the card supplier declines your payment, M/s. Vyapari Vyavasayi Ekopana
Samithi Palakkad is under no obligation to bring this fact to your attention. You
should check with your bank/credit/debit card supplier that payment has been
deducted from your account.
 </li> <li> In no event will M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad be liable for
any damages whatsoever arising out of the use, inability to use, or the results of
use of this site, any websites linked to this site, or the materials or information
contained at any or all such sites, whether based on warranty, contract, tort or
any other legal theory and whether or not advised of the possibility of such
damages.
 </li> <li> The Society shall not be any way responsible or pay any compensation for any
down-time that may occur. </li></ul>
      </div>

      <div class="d-flex pt-5">
        <h3>Confidentiality</h3>
      </div>
      <div class="pt-2"> The Society will maintain the confidentiality of each transaction and will not disclose
the commercially sensitive information, except to the extent necessary for the
Services.
      </div>

      <div class="d-flex pt-5">
        <h3>Refund Policy</h3>
      </div>
      <div class="pt-2"> Cancellation or refund policy are approved on case to case basis at the discretion of
the management. As per the guidelines provided at the initial stage it is the
agreement between the client and Society which has no effect with online payment
services.
<ul><li>
 If the customer leaves M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad,
before the completion of the period of the scheme of which he is a member,
there shall be no entitlement to a refund of paid service fees towards such
schemes.</li> <li>
 Refunds, if applicable, at the discretion of the Management, will only be made to
the debit/credit card used for the original transaction. For the avoidance of doubt
nothing in this Policy shall require M/s. Vyapari Vyavasayi Ekopana Samithi
Palakkad to refund the Amount (or part thereof) unless such Amount (or part
thereof) have previously been paid.</li> <li>
 In no event will M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad be liable for
any damages, whatsoever, arising out of the use, inability to use, or the results
of use of this site, any websites linked to this site, or the materials or information
contained at any or all such sites, whether based on warranty, contract, tort or
any other legal theory and whether or not advised of the possibility of such
damages.</li> <li>
 The Society shall not be any way responsible or pay any compensation for any
down-time that may occur.</li>
</ul>
      </div>

      <div class="d-flex pt-5">
        <h3>Privacy Policy</h3>
      </div>
      <div class="pt-2"> This Privacy Policy applies to all payments listed by M/s. Vyapari Vyavasayi
Ekopana Samithi Palakkad. If you have any questions about this Privacy Policy,
please feel free to contact us at <a href="kvves.pkd.wesuport@gmail.com">kvves.pkd.wesuport@gmail.com</a>
      </div>

      <div class="d-flex pt-5">
        <h3>Changes to our Privacy Policy</h3>
      </div>
      <div class="pt-2"> M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad. reserves the entire right to
modify/amend/remove this privacy statement anytime and without any reason.
Nothing contained herein creates or is intended to create a contract/agreement
between M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad. and any user visiting
M/s. Vyapari Vyavasayi Ekopana Samithi Palakkad. app or providing identifying
information of any kind.
      </div>
    </div>
  </v-sheet>
</div>
</template>
<script>
export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>